import axios from 'axios';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// Ensure TypeScript recognizes Pusher globally
declare global {
  interface Window {
    Pusher: typeof Pusher;
    Echo: Echo<any>;
  }
}
window.Pusher = Pusher;

// Debug environment variables
// console.log('Echo configuration:', {
//     key: import.meta.env.VITE_REVERB_APP_KEY ? '***' : 'NOT SET',
//     wsHost: import.meta.env.VITE_REVERB_HOST,
//     wsPort: import.meta.env.VITE_REVERB_PORT,
//     scheme: import.meta.env.VITE_REVERB_SCHEME,
// });

window.Echo = new Echo({
  broadcaster: 'reverb',
  key: import.meta.env.VITE_REVERB_APP_KEY as string,
  wsHost: import.meta.env.VITE_REVERB_HOST as string,
  wsPort: (import.meta.env.VITE_REVERB_PORT as unknown as number) ?? 80,
  wssPort: (import.meta.env.VITE_REVERB_PORT as unknown as number) ?? 443,
  forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
  enabledTransports: ['ws', 'wss'],
  encrypted: true,
  authorizer: (channel: any, options: any) => {
    return {
      authorize: (socketId: string, callback: (error: boolean, data: any) => void) => {
        axios
          .post(
            '/broadcasting/auth',
            {
              socket_id: socketId,
              channel_name: channel.name,
            },
            {
              headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            },
          )
          .then((response) => {
            callback(false, response.data);
          })
          .catch((error) => {
            console.error('Broadcasting auth failed for channel:', channel.name, {
              error: error.response?.data || error.message,
              status: error.response?.status,
              url: error.config?.url,
            });
            callback(true, error);
          });
      },
    };
  },
});
export default window.Echo;
